import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import {
  fetchBillingInvoices,
  clearFetchBillingInvoices,
  clearFetchSingleInvoicePdf,
} from 'redux/billing/actions';

import { Loader } from 'semantic-ui-react';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import CommonMessage from 'components/common/CommonMessage';
import BillingInvoicesList
  from 'components/dashboard/billing-content/BillingInvoicesList';

import { performDownload } from 'utils/common';

import './BillingInvoicesContent.css';

const BillingInvoicesContent = props => {
  const {
    fetchBillingInvoices,
    clearFetchBillingInvoices,
    billingInvoices,
    billingInvoicesError,
    singleInvoicePdf,
    clearFetchSingleInvoicePdf,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    fetchBillingInvoices();
    return () => {
      clearFetchBillingInvoices();
      clearFetchSingleInvoicePdf();
    };
  }, []);

  useEffect(() => {
    if (singleInvoicePdf) {
      performDownload(`invoice.pdf`, singleInvoicePdf);
    }
  }, [singleInvoicePdf]);

  if (billingInvoices && billingInvoices.no_items) return null;

  const loader = !billingInvoices && !billingInvoicesError &&
    <Loader active inline="centered" />;
  const invoicesList = billingInvoices && billingInvoices.length > 0 &&
    <BillingInvoicesList billingInvoices={billingInvoices} />;
  const invoicesError = billingInvoicesError &&
    billingInvoicesError.error &&
    (
    <CommonMessage
      error
      content={billingInvoicesError.error}
    />
  );

  return (
    <DashboardFormSection
      header={t("INVOICES")}
      className="billing-invoices-content__component"
    >
      {loader}
      {invoicesList}
      {invoicesError}
    </DashboardFormSection>
  );
};

BillingInvoicesContent.propTypes = {
  fetchBillingInvoices: PropTypes.func.isRequired,
  clearFetchBillingInvoices: PropTypes.func.isRequired,
  clearFetchSingleInvoicePdf: PropTypes.func.isRequired,
  billingInvoices: PropTypes.arrayOf(PropTypes.shape),
  billingInvoicesError: PropTypes.object,
  singleInvoicePdf: PropTypes.string,
  singleInvoicePdfError: PropTypes.object,
};

BillingInvoicesContent.defaultProps = {
  billingInvoices: null,
  billingInvoicesError: null,
  singleInvoicePdf: null,
  singleInvoicePdfError: null,
};

const mapStateToProps = state => (
  {
    billingInvoices: state.billingReducer.billingInvoices,
    billingInvoicesError: state.billingReducer.billingInvoicesError,
    singleInvoicePdf: state.billingReducer.singleInvoicePdf,
    singleInvoicePdfError: state.billingReducer.singleInvoicePdfError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchBillingInvoices,
    clearFetchBillingInvoices,
    clearFetchSingleInvoicePdf,
  },
)(BillingInvoicesContent);
